import React, { useState, useEffect, useRef } from 'react';
import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import moment from 'moment';

import { AddButton } from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../../components/common/FilterBy';
import { SearchBar } from '../../../components/common/SearchBar';
import {
  CustomPagination,
  PersitedDatePicker,
  TableCustom,
  TextAreaInput,
} from '../../../components/common';
import useDebounce from '../../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
} from '../../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../../components/common/Modal';
import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import { IData } from './helpers/interfaces';
import ViewFile from './components/ViewFile';
import formatDate from '../../../components/common/formatDate';
import TableScroll from '../../../components/ui/renderTable/TableScroll';
import CustomUploadButton from '../../../components/common/button/CustomUploadButton';

const tableHeaderObj = [
  [
    { text: 'S.NO.', rowspan: 1, colspan: 1 },
    { text: 'DATE', rowspan: 1, colspan: 1 },
    { text: 'CUSTOMER', rowspan: 1, colspan: 1 },
    { text: 'MODE OF COMPLAINT', rowspan: 1, colspan: 1 },
    { text: 'PART NAME', rowspan: 1, colspan: 1 },
    { text: 'Problem/Defect', rowspan: 1, colspan: 1 },
    {
      text: 'Information to Top Management & Operator',
      rowspan: 1,
      colspan: 1,
    },
    { text: 'CAUSE', rowspan: 1, colspan: 1 },
    { text: 'ACTION', rowspan: 1, colspan: 1 },
    { text: 'TARGET Dt.', rowspan: 1, colspan: 1 },
    { text: 'Actual Completion', rowspan: 1, colspan: 1 },
    { text: '1', rowspan: 1, colspan: 1 },
    { text: '2', rowspan: 1, colspan: 1 },
    { text: '3', rowspan: 1, colspan: 1 },
    { text: '4', rowspan: 1, colspan: 1 },
    { text: '5', rowspan: 1, colspan: 1 },
    { text: '6', rowspan: 1, colspan: 1 },
    { text: 'PFD', rowspan: 1, colspan: 1 },
    { text: 'CP', rowspan: 1, colspan: 1 },
    { text: 'FMEA', rowspan: 1, colspan: 1 },
    { text: 'WI', rowspan: 1, colspan: 1 },
    { text: 'Q Alert', rowspan: 1, colspan: 1 },
    { text: 'Remark/Status', rowspan: 1, colspan: 1 },
    { text: 'DEFECT PHOTO', rowspan: 1, colspan: 1 },
    { text: 'SUPPORTING DOCUMENTS', rowspan: 1, colspan: 1 },
    { text: 'ACTION', rowspan: 1, colspan: 1 },
  ],
];

//const filterOptions = [{ value: 'customer_name', name: 'Customer Name' }];
//const newFilterOptions = [{ value: 'defect_name', name: 'Defect Reported' }];

const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [complaintId, setComplaintId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const [id, setId] = useState<string | null>(null);
  const [isFileOpenPopup, setIsFileOpenPopup] = useState(false);
  const [contentType, setContentType] = useState('');
  const [filterCustomer, setFilterCustomer] = useState<any>([]);
  const [filterDefectsReported, setFilterDefectsReported] = useState<any>([]);
  const search = useQuery('search') || '';
  const filter = useQuery('filter') || 'createdAt';
  const page = useQuery('page') || 1;
  const customer = useQuery('customer');
  const defect = useQuery('defects');
  const date = useQuery('date');
  const [all, setAll] = useState(false);
  const [docFiles, setDocFiles] = useState<any>({});
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenFiles, setIsOpenFiles] = useState(false);
  const idRef = useRef<any>({});
  const [files, setFiles] = useState<any>(null);
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this?',
  );

  useEffect(() => {
    axios
      .get('/api/customerRoutes/get/customerForAutoComplete')
      .then((res) => {
        if (res?.data) {
          const formattedData = res.data.map((customer: any) => ({
            name: customer.customer_name,
            value: customer.customer_name,
          }));
          setFilterCustomer([
            // { value: 'NONE', name: 'NONE' },
            ...formattedData,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get('/api/defectRoutes/defectList/defectForAutoComplete')
      .then((res) => {
        if (res?.data) {
          const formattedData = res.data.map((defect: any) => ({
            name: defect.defect_name,
            value: defect.defect_name,
          }));
          setFilterDefectsReported([
            // { value: 'NONE', name: 'NONE' },
            ...formattedData,
          ]);
        }
      })
      .catch((err) => console.log(err));
  }, []);
  const fetchData = async () => {
    if (!date) return;
    const res = await axios
      .get(
        `/api/customerComplaintRoutes/?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}&customer=${customer}&defects=${defect}&all=${all}&date=${date}`,
      )
      .catch((err) => {
        console.log(err);
      });

    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const deleteCustomerConcern = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/customerComplaintRoutes/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };
  const uploadFile = async (e: any, item: any) => {
    if (!window.confirm('Are you sure you want upload this Files')) return;
    const files = e.target.files;
    if (!files) return;
    let formData = new FormData();
    for (const key of Object.keys(files)) {
      formData.append('files', files[key]);
    }
    setIsLoading(true);
    axios
      .patch(`/api/customerComplaintRoutes/handleUpload/${item._id}`, formData)
      .then((res) => {
        if (res.data) {
          alert('document upload successly');
          setIsLoading(false);
          setRender((prev) => !prev);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useDebounce(fetchData, 500, [
    page,
    search,
    render,
    isModal,
    filter,
    customer,
    defect,
    all,
    date,
  ]);
  return (
    <>
      <ChildHeader text="CUSTOMER Complaint REGISTER">
        <AddButton
          onClick={() => {
            setAll((value) => !value);
          }}
          label={all ? 'Hide' : 'Save'}
        />
        <AddButton
          onClick={() => setIsModal(true)}
          label="NEW CUSTOMER Complaint"
        />
      </ChildHeader>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent={'space-between'}
        sx={{
          alignItems: 'center',
          margin: '15px',
          width: '95%',
          gap: 2,
        }}
      >
        <PersitedDatePicker label="Search By Month" views={['month', 'year']} />
        <Stack direction={{ xs: 'column', sm: 'row' }}>
          <FilterBy
            name="customer"
            variant="outlined"
            label="Filter By Customer"
            options={filterCustomer}
            sx={{ width: 300 }}
          />
          <FilterBy
            variant="outlined"
            name="defects"
            label="Filter By Defects Reported"
            options={filterDefectsReported}
            sx={{ width: 300, marginLeft: 2 }}
          />
        </Stack>
      </Stack>

      <TableScroll>
        <TableCustom tableHeaderObj={tableHeaderObj}>
          <TableBody>
            {data &&
              data.map((item: IData, index: number) => (
                <React.Fragment key={item._id}>
                  <TableRow>
                    <TableCell align="center">
                      {perPage * (+page - 1) + index + 1}
                    </TableCell>
                    <TableCell align="center">
                      {item.issue_reported_date &&
                        formatDate(item.issue_reported_date)}
                    </TableCell>
                    <TableCell align="center">
                      {item.customer_id?.customer_name}
                    </TableCell>
                    <TableCell align="center">
                      {item.type_of_complaint}
                    </TableCell>
                    <TableCell align="center">
                      {item.part_id?.part_name}
                    </TableCell>
                    <TableCell align="center">
                      {item.defect_id?.defect_name}
                    </TableCell>
                    <TableCell align="left" style={{ minWidth: '200px' }}>
                      <TextAreaInput value={item.information} />
                    </TableCell>
                    <TableCell align="left" style={{ minWidth: '200px' }}>
                      <TextAreaInput value={item.root_cause} />
                    </TableCell>
                    <TableCell align="left" style={{ minWidth: '200px' }}>
                      <TextAreaInput value={item.action_taken} />
                    </TableCell>
                    <TableCell align="center">
                      {item.target_date && formatDate(item.target_date)}
                    </TableCell>
                    <TableCell align="center">
                      {item.actual_closure_date &&
                        formatDate(item.actual_closure_date)}
                    </TableCell>
                    {['jan', 'feb', 'mar', 'apr', 'may', 'jun'].map(
                      (month: any) => {
                        return (
                          <TableCell
                            style={{
                              ...(item[month] &&
                                item[month].toLowerCase() === 'repeated' && {
                                  background: '#e03131',
                                }),
                              ...(item[month] &&
                                item[month].toLowerCase() ===
                                  'not repeated' && {
                                  background: '#2f9e44',
                                }),
                              minWidth: '50px',
                            }}
                            align="center"
                          ></TableCell>
                        );
                      },
                    )}
                    <TableCell align="center">{item.pfd}</TableCell>
                    <TableCell align="center">{item.control_plan}</TableCell>
                    <TableCell align="center">{item.pfmea}</TableCell>
                    <TableCell align="center">{item.quality_alert}</TableCell>
                    <TableCell align="center">{item.wi}</TableCell>
                    <TableCell align="center">{item.remarks}</TableCell>
                    <TableCell align="center">
                      <Stack direction="row" sx={{ justifyContent: 'center' }}>
                        <CustomUploadButton
                          lable={'Defect photo'}
                          id={`${index}_iamges`}
                          multiple
                          accept="image/png,image/jpeg,image/jpg"
                          onChange={(e) => {
                            uploadFile(e, item);
                          }}
                        />
                        {item.images && item.images.length > 0 && (
                          <ViewIconButton
                            tooltipTitle="view"
                            onClick={() => {
                              setId(item._id || null);
                              setIsFileOpenPopup(true);
                              setContentType('image');
                            }}
                          />
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      <Stack direction="row" sx={{ justifyContent: 'center' }}>
                        <CustomUploadButton
                          lable={'Attach Doucments'}
                          id={`${index}_files`}
                          multiple
                          accept="application/pdf,application/doc,application/excel/,application/ppt"
                          onChange={(e) => {
                            uploadFile(e, item);
                          }}
                        />
                        {item.files && item.files.length > 0 && (
                          <ViewIconButton
                            tooltipTitle="view"
                            onClick={() => {
                              setId(item._id || null);
                              setIsFileOpenPopup(true);
                              setContentType('file');
                            }}
                          />
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" sx={{ justifyContent: 'center' }}>
                        <EditIconButton
                          tooltipTitle="EDIT"
                          onClick={() => {
                            setComplaintId(item?._id || '');
                            setIsModal(true);
                          }}
                        />

                        <DeleteIconButton
                          tooltipTitle="DELETE"
                          onClick={() => {
                            deleteCustomerConcern(item?._id || '');
                          }}
                        />
                      </Stack>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </TableCustom>
      </TableScroll>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setComplaintId(null);
          setIsModal(false);
        }}
        title="CUSTOMER Complaint REGISTER"
      >
        <Create id={complaintId} setIsModal={setIsModal} />
      </ModalCustom>
      <ModalCustom
        title="FILE LIST"
        openModal={isFileOpenPopup}
        closeModal={() => {
          setId(null);
          setIsFileOpenPopup(false);
        }}
      >
        <ViewFile id={id} contentType={contentType} />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
